import { IMAGE_HEADER_BYTES, IMAGE_MAGIC_BYTES, imagesSchema } from '@domain/schemas/images.schema';

// The backend stays the authority: this check only lets the user see a specific reason before the
// upload, and a client can skip it.

export const INVALID_IMAGE_CONTENT_ERROR = 'The content of the file does not match its type. Upload a real JPG or PNG.';

// FileReader rather than Blob.arrayBuffer(): jsdom does not implement the latter.
const readHeader = (file: File): Promise<Uint8Array> =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(new Uint8Array(reader.result as ArrayBuffer));
    reader.onerror = () => reject(reader.error);
    reader.readAsArrayBuffer(file.slice(0, IMAGE_HEADER_BYTES));
  });

/** Resolves to an error message, or `undefined` when the file content matches its declared type. */
export const validateImageFile = async (file: File): Promise<string | undefined> => {
  const type = imagesSchema.shape.type.safeParse(file.type);
  if (!type.success) {
    return INVALID_IMAGE_CONTENT_ERROR;
  }
  const signature = IMAGE_MAGIC_BYTES[type.data];

  try {
    const header = await readHeader(file);

    return signature.every((byte, i) => header[i] === byte) ? undefined : INVALID_IMAGE_CONTENT_ERROR;
  } catch (_error) {
    // An unreadable file (revoked permission, deleted after selection) cannot be uploaded either.
    return INVALID_IMAGE_CONTENT_ERROR;
  }
};
